import { createContext } from "react";
var defaultState = { tasks: [] };
export var TaskEditContext = createContext(defaultState);
